import React, { useEffect, useState } from "react";
import axios from "../../../../../axios";
import ChannelRequest from "./ChannelRequest";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";

function SingleChannelRequest({
  communityId,
  setPostRequestCount,
  setRejectedPostCount,
  setIsPostCreated,
  setIsPostDeclined,
  getCommuntiy,
  setRequestPostCountRejected,
}) {
  const [requestList, setRequestList] = useState([]);
  const [postStatusChanged, setPostStatusChanged] = useState("");
  const [inProgress, setInProgress] = useState(true);

  const [filter, setFilter] = useState({
    limit: 10,
    page: 1,
    sortBy: -1,
  });

  const { limit, page, sortBy } = filter;

  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("single-channel-request-scroll").clientHeight +
          document.getElementById("single-channel-request-scroll").scrollTop +
          1 >=
        document.getElementById("single-channel-request-scroll").scrollHeight
      ) {
        setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const element = document.getElementById("single-channel-request-scroll");
    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchRequests = async () => {
      setInProgress(true);
      try {
        const postRequest = await axios.get(
          `/api/v1/community/post/getBystatus/pending/${communityId}?_page=${page}&_limit=${limit}&sortBy=${sortBy}`
        );
        if (postRequest) {
          const isNotDeletedPost = postRequest.data.data.filter(
            (post) => post.isDeleted !== true
          );
          if (page === 1) {
            setRequestList(isNotDeletedPost); // reset list for first page
          } else {
            setRequestList((prev) => [...prev, ...isNotDeletedPost]);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setInProgress(false);
      }
    };

    fetchRequests();
  }, [postStatusChanged]); // fetch again when status changes

  // postStatusChanged;
  return (
    <div>
      {inProgress ? (
        <div className="loader_container">
          <img
            className="request_post_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : requestList && requestList?.length > 0 ? (
        requestList.map((requestPost) => (
          <ChannelRequest
            setPostRequestCount={setPostRequestCount}
            key={requestPost.id}
            requestPost={requestPost}
            setFilter={setFilter}
            filter={filter}
            setInProgress={setInProgress}
            setPostStatusChanged={setPostStatusChanged}
            setRejectedPostCount={setRejectedPostCount}
            postStatusChanged={postStatusChanged}
            setRequestList={setRequestList}
            setIsPostCreated={setIsPostCreated}
            setIsPostDeclined={setIsPostDeclined}
            getCommuntiy={getCommuntiy}
          />
        ))
      ) : (
        <Box
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ backgroundColor: "#f5f5f5", p: 2 }}
        >
          <Stack alignItems="center" spacing={2}>
            <Typography
              variant="h6"
              color="text.secondary"
              className="poppins-semibold"
            >
              No Requests yet.
            </Typography>
          </Stack>
        </Box>
      )}
    </div>
  );
}

export default SingleChannelRequest;
